import { login, logOut, setLoginAccount } from "./authActions";
import {WebUser} from "../../models/WebUser";

export interface AuthState {
  isLoggedIn: boolean;
  webUser: WebUser;
  loading: boolean;
}

const initialAuth: AuthState = {
  isLoggedIn: false,
  loading: false,
  webUser: {} as WebUser,
};

export default function authReducer(authState = initialAuth, action: any) {
  switch (action.type) {
    case login.pending.toString():
      return { ...authState, loading: true };
    case login.rejected.toString():
      return {
        ...authState,
        loading: false,
        isLoggedIn: false,
      };
    case setLoginAccount.toString():
      return {
        ...authState,
        loading: false,
        isLoggedIn: true,
        webUser: action.payload,
      };
    case logOut.toString():
      return initialAuth;
    default:
      return authState;
  }
}
